import { z } from 'zod';

export const TaskStatus = z.enum(['OPEN', 'COMPLETED', 'ARCHIVED', 'SKIPPED']);
export type TaskStatus = z.infer<typeof TaskStatus>;
